import type { FC, ReactNode } from 'react'

import type { WhiteLabel } from '@skytech/types'
import { twJoin } from 'tailwind-merge'

import './styles.scss'

export type InfoBoxEmphasis = 'info' | 'warning' | 'error'

export const InfoBox: FC<{
  children: ReactNode
  marginBottom?: number
  marginRight?: number
  marginTop?: number
  marginLeft?: number
  emphasis?: InfoBoxEmphasis
  className?: string
}> = ({
  children,
  emphasis = 'info',
  className = '',
  marginBottom = 0,
  marginRight = 0,
  marginTop = 0,
  marginLeft = 0,
}) => {
  // todo: replace with the org from url when ready
  const whiteLabel = localStorage.getItem('org') as WhiteLabel

  return (
    <div
      className={twJoin(
        `ui-info-box ${className} ${emphasis} ${whiteLabel} mb-[${marginBottom}] mr-[${marginRight}] mt-[${marginTop}] ml-[${marginLeft}]`,
        className
      )}
    >
      {children}
    </div>
  )
}
